<template>
  <a-modal
    :title="title"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :width="800"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form-model
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 16 }"
    >
      <a-form-model-item :label="'保证金金额'" prop="amount">
        <a-input-number
          v-model="form.amount"
          :placeholder="'请输入保证金金额'"
          :min="0"
          :precision="2"
          :style="{ width: '100%' }"
        />
      </a-form-model-item>

      <a-form-model-item :label="'最高日提现额度'" prop="dailyWithdrawLimit">
        <a-input-number
          v-model="form.dailyWithdrawLimit"
          :placeholder="'请输入最高日提现额度'"
          :min="0"
          :precision="2"
          :style="{ width: '100%' }"
        />
      </a-form-model-item>

      <a-form-model-item :label="'排序号'" prop="sortNum">
        <a-input-number
          v-model="form.sortNum"
          :placeholder="'请输入排序号'"
          :min="0"
          :style="{ width: '100%' }"
        />
      </a-form-model-item>

      <a-form-model-item :label="'状态'" prop="status">
        <a-radio-group v-model="form.status">
          <a-radio :value="1">{{ '启用' }}</a-radio>
          <a-radio :value="0">{{ '禁用' }}</a-radio>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item :label="'备注'" prop="remark">
        <a-textarea
          v-model="form.remark"
          :placeholder="'请输入备注'"
          :rows="4"
          :maxLength="500"
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { addShopDepositConfig, updateShopDepositConfig, getShopDepositConfig } from '@/api/shop/shopDepositConfig'

export default {
  name: 'ShopDepositConfigForm',
  data() {
    return {
      title: '',
      visible: false,
      confirmLoading: false,
      form: {
        id: undefined,
        amount: undefined,
        dailyWithdrawLimit: undefined,
        sortNum: 0,
        status: 1,
        remark: undefined
      },
      rules: {
        amount: [
          { required: true, message: '保证金金额不能为空', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (value === '' || value === null || value === undefined) {
              callback()
            } else {
              const num = parseFloat(value)
              if (isNaN(num)) {
                callback(new Error('请输入有效的数字'))
              } else if (num < 0.01) {
                callback(new Error('保证金金额必须大于0'))
              } else {
                callback()
              }
            }
          }, trigger: 'blur' }
        ],
        dailyWithdrawLimit: [
          { required: true, message: '最高日提现额度不能为空', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (value === '' || value === null || value === undefined) {
              callback()
            } else {
              const num = parseFloat(value)
              if (isNaN(num)) {
                callback(new Error('请输入有效的数字'))
              } else if (num < 0.01) {
                callback(new Error('最高日提现额度必须大于0'))
              } else {
                callback()
              }
            }
          }, trigger: 'blur' }
        ],
        sortNum: [
          { required: true, message: '排序号不能为空', trigger: 'blur' },
          { type: 'number', min: 0, message: '排序号不能为负数', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态不能为空', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    /** 新增按钮 */
    handleAdd() {
      this.reset()
      this.title = '新增保证金配置'
      this.visible = true
    },
    /** 修改按钮 */
    handleUpdate(row, ids) {
      if (ids && ids.length === 1) {
        const id = ids[0]
        getShopDepositConfig(id).then(response => {
          this.form = { ...response.data }
        })
      } else if (row) {
        this.form = { ...row }
      } else {
        this.$message.warning('请选择一条数据')
        return
      }
      this.title = '修改保证金配置'
      this.visible = true
    },
    /** 确定按钮 */
    handleOk() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.confirmLoading = true
          if (this.form.id) {
            updateShopDepositConfig(this.form).then(() => {
              this.handleCancel()
              this.$emit('ok')
              this.$message.success('修改成功')
            }).finally(() => {
              this.confirmLoading = false
            })
          } else {
            addShopDepositConfig(this.form).then(() => {
              this.handleCancel()
              this.$emit('ok')
              this.$message.success('新增成功')
            }).finally(() => {
              this.confirmLoading = false
            })
          }
        }
      })
    },
    /** 取消按钮 */
    handleCancel() {
      this.visible = false
      this.reset()
    },
    /** 表单重置 */
    reset() {
      this.$refs.form.resetFields()
      this.form = {
        id: undefined,
        amount: undefined,
        dailyWithdrawLimit: undefined,
        sortNum: 0,
        status: 1,
        remark: undefined
      }
    }
  }
}
</script>

<style scoped>
</style>
